var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work"},[_c('div',{staticClass:"work_top"},[_c('van-icon',{staticStyle:{"position":"absolute","left":"10px"},attrs:{"size":"25","name":"arrow-left"},on:{"click":function($event){return _vm.to()}}}),_c('div',{staticClass:"my"},[_vm._v("不通过原因")])],1),_c('div',{staticClass:"work_bottom"},[_vm._v(_vm._s(_vm.cause))])])
}
var staticRenderFns = []

export { render, staticRenderFns }